export default "__VITE_ASSET__be472c5c__"